import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { clearSelectedData, clearValidateTriggered } from "redux/formDisplay";
import { incrementActiveStepOrder } from "redux/conditionalRendering";
import Toast from "components/ToastComponent";
import { useState } from "react";
import { getRecordsByQuery } from "api/uae-pass";

const DynamicButton = (props) => {
  const {
    label,
    className,
    variant,
    custom_styles,
    action,
    show,
    disabled,
    applicantData,
    setShowPopover,
    handleItemClick,
    setSelectedData,
  } = props;
  const activeStepOrder = useSelector(
    (state) => state.conditionalRendering?.activeStepOrder
  );
  const currentStep = useSelector((state) =>
    state.stepperReducer?.sections[1]?.form_groups.find(
      (group) => group.group_order === activeStepOrder
    )
  );
  const IndirectEval = (evalString) => {
    return eval(evalString);
  };
  const dispatch = useDispatch();
  const selectedData = useSelector((state) => state.formData?.selectedData);
  const [messageToast, setMessageToast] = useState({ type: "", msg: "", id: '' });

const handleClick = async (action) => {
  try {
    if (action === "skip_otp") {
      dispatch(clearValidateTriggered());
      dispatch(incrementActiveStepOrder(IndirectEval(currentStep.next_step) + 1));
      return;
    }
    if (action === "validate_email") {
      dispatch(incrementActiveStepOrder(IndirectEval(currentStep.next_step)));
      return; 
    }
    if (action === "proceed") {
      dispatch(incrementActiveStepOrder(IndirectEval(currentStep.next_step) + 1));
      return;
    }
    if (action === 'assign_poc') { 
      let body = {
              userId: applicantData?.workflow_id,
              workFlowId: applicantData?.workflow_id,
              "label": selectedData?.internal_poc_name,
              "value": selectedData?.internal_poc_user_id,
              "email": selectedData?.internal_poc_email_id,
              "mobile_number": selectedData?.internal_poc_mobile_number,
            };
      await handleItemClick(action, body, applicantData?.workflow_id)
      setShowPopover(false);
      setTimeout(() => {
        setShowPopover(undefined);
      }, 1);
      dispatch(clearSelectedData())
      return;
    } 
    if (action === 'check_uaepass_mail') {
      const email = selectedData?.validate_email;
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      if (!isValidEmail) {
        setMessageToast({
          type: "error",
          msg: "Please enter a valid email address",
          id: Date.now(),
        });
        dispatch(clearSelectedData())
        return;
      }
      dispatch(setSelectedData({ key: "valid_email", value: true }));
      const query = { "source_data.subworkflows.email": email };
      const response = await getRecordsByQuery({ query });
      if (response?.status === "success" && response.data) {
        dispatch(setSelectedData(email));
        dispatch(incrementActiveStepOrder(IndirectEval(currentStep.next_step)));
      } else if (response?.status === "failed") {
        setMessageToast({
          type: "error",
          msg: "Email address not found; a new account will be linked",
          id: Date.now()
        });
        setTimeout(() => {
          dispatch(clearValidateTriggered());
          dispatch(incrementActiveStepOrder(IndirectEval(currentStep.next_step) + 1));
        }, 4000);
      }
      dispatch(setSelectedData({ key: "valid_email", value: false }));
      return
    }
    dispatch(incrementActiveStepOrder(IndirectEval(currentStep.next_step)));
  }catch (error) {
    console.error("Error occurred in handleClick:", error);
    setMessageToast({
      type: "error",
      msg: "An unexpected error occurred. Please try again.",
    });
  }
};

return (
  <>
    {messageToast?.msg && (
      <Toast message={messageToast?.msg} type={messageToast?.type} id={messageToast?.id} autoClose={messageToast.autoClose} />
    )}
    {eval(show) && (
      <Button
        onClick={() => handleClick(action)}
        className={`${className} mt-10 .px-3 w-25 mx-auto my-3 my-lg-4 ${custom_styles}`}
        variant={variant}
        disabled={disabled && IndirectEval(disabled)}
      >
        {label}
      </Button>
    )}
  </>
); 
};
export default DynamicButton;